/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
 * Written in 2024
 */

/* eslint-disable */
import axios from 'axios';
import getEnv from '@/utils/env';
import { oktaAuth } from '@/plugins/okta';

const client = axios.create({
  baseURL: getEnv('BACKEND_URL'),
  json: true,
});

client.interceptors.request.use(
  async (config) => {
    const conf = config;

    try {
      const idToken = oktaAuth.getIdToken();
      if (idToken) {
        conf.headers.Authorization = 'Bearer ' + idToken;
      }
    } catch (error) {
      console.error('[API Client] Error getting Okta token:', error);
    }

    return conf;
  },
  (error) => Promise.reject(error)
);

export default client;
